import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SecurityService } from 'app/core/security/security.service';
import { SystemMessageService } from 'app/core/system-message/system-message-service';
import { validateForm } from 'app/shared/form-elements/form-validateForm.function';
import { ChangePasswordForm } from './change-password.form';
import { UserResetTokenResponseVm } from 'app/shared/generated/Models/UserResetTokenResponseVm';


@Component({
    selector: 'pcg-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

	// Our form group
	changePasswordForm: UntypedFormGroup = null;

	// Change password subscription
	changePasswordSub: Subscription = new Subscription();

	// Fields sent to server with form
	token = '0';
	userId = '0';
	code = '';
	isExpired = false;
	errorMessage = "";

	constructor(private route: ActivatedRoute, private ms: SystemMessageService,
		private sec: SecurityService, private router: Router, private http: HttpClient) {
			const changePasswordForm = new ChangePasswordForm(http);
			this.changePasswordForm = changePasswordForm.formGroup;
	}

	// Get query parameters on init
	ngOnInit() {
		this.token = this.route.snapshot.queryParams.token;
		this.userId = this.route.snapshot.queryParams.userId;
		this.code = this.route.snapshot.queryParams.code;
        const safeToken = encodeURIComponent(this.token); 

		if (this.token != null) {
			this.changePasswordSub.add(
				this.http.get(`api/Account/GetUserResetTokenStatus?token=${safeToken}&userId=${this.userId}`)
					.subscribe((vm: UserResetTokenResponseVm) => {
                        this.isExpired = vm.isExpired;
                        if (vm.isExpired) {
                            this.errorMessage = vm.message;
                        }
					})
			);
		} else { this.ms.setSystemMessage("There was a problem processing your change password request. Please contact an administrator.", "Error"); }
		
	}

	onSubmit() {
		if (this.changePasswordForm.valid) {
			this.changePasswordSub.add(
				this.ms.getHttpObservable(this, 'api/Account/ChangePassword', this.changePasswordForm,
					{ userId: this.userId, code: this.code, token: this.token })
					.subscribe(msg => {
						if (msg?.isSuccessful) {
							this.router.navigate(['/']);
						}
					})
			);
		} else { validateForm(this.changePasswordForm); }
	}

	ngOnDestroy() { this.changePasswordSub.unsubscribe(); }
}
